import React, { useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import t from './../data/en_new.json'

import { SavedTripsContext } from './../utils/savedTripsContext'
import arrowTopRight from './../images/arrow-topright-pointing.svg'

const Container = styled.div`
  font-family: 'Sica', sans-serif;
  display: grid;
  grid-area: 1/1;
  position: relative;
  place-items: center;
  max-width: 920px;
  min-width: 70%;
  padding: 0;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media screen and (min-width: 992px) {
    padding: 0;
    min-width: auto;
  }
`

const FooterTitle = styled.h2`
  font-family: 'swear-display';
  font-size: 45px;
  font-weight: 100;
  margin-bottom: 4rem;
`

const ContentHolder = styled.div`
  display: inline-block;
  vertical-align: top;
  font-size: 18px;
  
  @media screen and (min-width: 992px) {
    width: 65%;

    &:only-child{
      width: 100%;
    }
    padding: 0 8rem 0 0;
  }
`

const BookTrip = styled(ContentHolder)`
  display: block;
  margin-bottom: 60px;
`

const Explore = styled(ContentHolder)`
  margin-top: 2rem;
  @media screen and (min-width: 768px) {
    margin-top: 0;
  }
`

const LinkView = styled(Link)`
  color: #ffffff;
  text-decoration: underline;

  &:visited {
    color: #ffffff;
  }
`

const AnchorLink = styled.a`
  color: #ffffff;
  text-decoration: underline;

  &:visited {
    color: #ffffff;
  }
`;

const ParagraphExplore = styled.p`
  padding-top: 30px;
  padding-bottom: 30px;
  line-height: 1.5;
  width: auto;

  @media screen and (min-width: 768px) {
    min-height: 70px;
    padding-top: 0;
  }
`

const ParagraphTrip = styled.p`
  padding-bottom: 40px;
  line-height: 1.5;

  @media screen and (min-width: 768px) {
    min-height: 70px;
  }
`

const SaveTrip = styled.span`
  display: block;
  margin-right: 32px;
  margin-bottom: 20px;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    display: inline-block;
    margin-bottom: 0;
  }
`

const ArrowTopRight = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 10px;
  filter: invert(100%);
`

const FooterContent = ({ activity = '' }) => {
  const { savedTrips, setSavedTrips } = useContext(SavedTripsContext)

  const toggleSaved = () => {
    if(savedTrips.includes(activity)) {
      setSavedTrips(savedTrips.filter(value => value !== activity))
    } else {
      setSavedTrips([...savedTrips, activity])
    }
  }

  return (
    <Container>
      <div>
        {activity.length > 0 && <>
          <FooterTitle>
            {t.footer.title}
          </FooterTitle>
          <BookTrip>
            <ParagraphTrip>
              {t.footer.saveTripText}
            </ParagraphTrip>
            <SaveTrip onClick={() => toggleSaved()}>
              {savedTrips.includes(activity) ? t.footer.saved : t.footer.saveTripLink }
            </SaveTrip>
            <AnchorLink href="https://greengate.nemtilmeld.dk/20/" target="_blank" rel="noopener noreferrer">
              {t.footer.bookTrip} <ArrowTopRight src={arrowTopRight} alt="Arrow" />
            </AnchorLink>
          </BookTrip>
        </>}
        <Explore>
          <ParagraphExplore>
            <b>{t.footer.exploreMapText}</b>
          </ParagraphExplore>
          <LinkView to='/'>{t.footer.exploreMapLink}</LinkView>
        </Explore>
      </div>
    </Container>
  )
}

export default FooterContent
